/* The email-settings GET reports the tenant-level Reply-To as
   `quote_reply_email`; the PATCH accepts it as `reply_to`. Reading `reply_to`
   off the GET (it is never there) seeded the field blank, and saving the whole
   form then wrote '' over Tenant.quote_reply_email on every save. Seed from the
   field the GET returns, and send only what the user changed. */
export function emailFormFromSettings(data) {
  return {
    from_local_part: data?.from_local_part || 'quotes',
    reply_to: data?.quote_reply_email || '',
  };
}

export function changedEmailFields(form, baseline) {
  const out = {};
  Object.keys(form).forEach((k) => {
    if (form[k] !== baseline[k]) out[k] = form[k];
  });
  return out;
}
